import {AppState} from '../reducer';
import {SidePanelContent} from '../actions/types/grid.types';

export const showGridSelector = (state: AppState): boolean => state.gridReducer.showGrid;
export const sidePanelContentSelector = (state: AppState): SidePanelContent => state.gridReducer.sidePanelContent;
export const highlightedElementTabSelector = (state: AppState): string | null => state.gridReducer.highlightedElementTab;
